function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
//Limitless imports
import { withi18n } from "../../../../customer/components";
class DropDownList extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      dropDownValue: this.props.initialValue,
      hasChanged: false,
      labelWidth: 0
    });
    _defineProperty(this, "handleChange", event => {
      const {
        onChange,
        name,
        items
      } = this.props;
      this.setState({
        dropDownValue: event.target.value,
        hasChanged: true
      });

      //there should only ever be one in the array.
      const selectedItem = items.filter(item => {
        return item.value === event.target.value;
      })[0];
      onChange(name, selectedItem, event.target.value);
    });
  }
  componentWillReceiveProps(nextProps) {
    //if we receive a new list, reset the component's state
    if (this.state.hasChanged) {
      if (!this.props.items[0] || nextProps.items[0] && nextProps.items[0].name !== this.props.items[0].name) {
        this.setState({
          hasChanged: false,
          dropDownValue: nextProps.initialValue
        });
      }
    }
  }
  render() {
    const {
      classes,
      items,
      t,
      name,
      fullWidth,
      disabled,
      error,
      value
    } = this.props;
    const {
      dropDownValue
    } = this.state;
    const selectValue = value !== undefined ? value : dropDownValue;
    const portalInputClasses = {
      root: classes.root,
      focused: classes.focused,
      notchedOutline: classes.notchedOutline
    };
    return /*#__PURE__*/React.createElement(FormControl, {
      className: `${classes.formControl} ${fullWidth && classes.formControlFullWidth}`,
      error: error !== undefined,
      variant: "outlined"
    }, /*#__PURE__*/React.createElement(Select, {
      value: selectValue,
      onChange: this.handleChange,
      input: /*#__PURE__*/React.createElement(OutlinedInput, {
        name: name,
        id: `${name.toLowerCase()}DropDown`,
        classes: portalInputClasses
      }),
      classes: {
        root: `${classes.selectRoot} ${!fullWidth && classes.selectRootSmall} ${disabled ? classes.secondaryColor : classes.primaryColor}`,
        selectMenu: classes.selectMenu,
        icon: classes.selectIcon
      },
      IconComponent: KeyboardArrowDown,
      displayEmpty: true,
      disabled: disabled
    }, items.map((item, index) => {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: index,
        id: item.name,
        value: item.value
      }, t(item.name));
    })));
  }
}
const styles = theme => ({
  formControl: {
    justifyContent: "center"
  },
  formControlFullWidth: {
    width: "100%"
  },
  selectRoot: {
    height: 55,
    color: theme.palette.text.primary,
    borderRadius: 4
  },
  primaryColor: {
    color: theme.palette.text.primary
  },
  secondaryColor: {
    color: theme.palette.text.primary
  },
  selectRootSmall: {
    width: 180
  },
  selectMenu: {
    height: 50,
    padding: "0 0 0 15px",
    display: "flex",
    alignItems: "center",
    fontSize: "0.875rem",
    whiteSpace: "unset"
  },
  selectIcon: {
    top: "calc(50% - 17px)",
    height: "1.5em",
    width: "1.5em",
    color: "inherit"
  },
  root: {
    backgroundColor: theme.background.paper,
    "&:hover $notchedOutline": {
      borderColor: theme.palette.secondary.dark
    },
    "&$focused $notchedOutline": {
      borderColor: theme.palette.secondary.main,
      borderWidth: 2
    }
  },
  //Empty objects are needed to reset the MUI styles
  notchedOutline: {},
  focused: {}
});
export default withStyles(styles)(withi18n(DropDownList));
DropDownList.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  value: PropTypes.string,
  initialValue: PropTypes.string
};
DropDownList.defaultProps = {
  fullWidth: false,
  disabled: false,
  initialValue: "",
  value: undefined
};